module.exports = __webpack_public_path__ + "static/media/Spin-1s-200px.f38e38f7.svg";